import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import './Components/DetailsLayout.css'; // Modular details layout styles
import './utils/sharedStyles.css'; // Shared utility styles
import App from './App';

// Dev-only network diagnostics (never patch fetch in production builds)
if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line global-require
  require('./utils/networkMonitor');
}

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <Router>
    <App />
  </Router>
);
